import { render, staticRenderFns } from "./shippingTime.vue?vue&type=template&id=cc4fecf6&scoped=true"
import script from "./shippingTime.vue?vue&type=script&lang=js"
export * from "./shippingTime.vue?vue&type=script&lang=js"
import style0 from "./shippingTime.vue?vue&type=style&index=0&id=cc4fecf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4fecf6",
  null
  
)

export default component.exports